(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["attribution-tracking"] && !Shopify.designMode) return;
  try {
    const attributionStorageKey = 'qomoor:attribution-journey:v2';
  const attributePrefix = '__qm_';
  let attributionSyncPromise;
  let syncedOnPage = false;

  const truncateAttribute = (value) => String(value || '').trim().slice(0, 240);

  const marketingAllowed = () => {
    const customerPrivacy = window.Shopify?.customerPrivacy;
    return !customerPrivacy || customerPrivacy.marketingAllowed();
  };

  const externalReferrerHost = () => {
    if (!document.referrer) return '';

    try {
      const referrer = new URL(document.referrer);
      return referrer.hostname === window.location.hostname ? '' : referrer.hostname;
    } catch {
      return '';
    }
  };

  const buildAttribution = () => {
    const parameters = new URLSearchParams(window.location.search);
    const referrerHost = externalReferrerHost();
    const clickIds = [
      ['gclid', 'google', 'cpc'],
      ['gbraid', 'google', 'cpc'],
      ['wbraid', 'google', 'cpc'],
      ['fbclid', 'meta', 'paid_social'],
      ['msclkid', 'bing', 'cpc'],
      ['ttclid', 'tiktok', 'paid_social'],
      ['epik', 'pinterest', 'paid_social'],
    ];
    const clickMatch = clickIds.find(([parameter]) => parameters.has(parameter));
    const source = parameters.get('utm_source') || clickMatch?.[1] || referrerHost || 'direct';
    const medium = parameters.get('utm_medium') || clickMatch?.[2] || (referrerHost ? 'referral' : '(none)');

    return {
      attribution: {
        source,
        medium,
        campaign: parameters.get('utm_campaign') || '',
        content: parameters.get('utm_content') || '',
        term: parameters.get('utm_term') || '',
        click_id: clickMatch ? parameters.get(clickMatch[0]) || '' : '',
        landing_path: window.location.pathname + window.location.search,
        referrer_host: referrerHost,
        captured_at: new Date().toISOString(),
      },
      hasAcquisitionSignal:
        parameters.has('utm_source') ||
        parameters.has('utm_medium') ||
        parameters.has('utm_campaign') ||
        Boolean(clickMatch) ||
        Boolean(referrerHost),
    };
  };

  const readStoredAttribution = () => {
    try {
      const stored = window.localStorage.getItem(attributionStorageKey);
      return stored ? JSON.parse(stored) : null;
    } catch {
      return null;
    }
  };

  const captureAttribution = () => {
    if (!marketingAllowed()) return null;

    const stored = readStoredAttribution();
    const candidate = buildAttribution();
    const journey = {
      first: stored?.first || candidate.attribution,
      last: candidate.hasAcquisitionSignal ? candidate.attribution : stored?.last || candidate.attribution,
    };

    try {
      window.localStorage.setItem(attributionStorageKey, JSON.stringify(journey));
    } catch {
      return journey;
    }

    return journey;
  };

  const privateCartAttributes = (journey) => {
    const attributes = {};

    for (const touchpoint of ['first', 'last']) {
      for (const [key, value] of Object.entries(journey[touchpoint] || {})) {
        if (value) attributes[attributePrefix + touchpoint + '_' + key] = truncateAttribute(value);
      }
    }

    return attributes;
  };

  const syncAttributionToCart = async () => {
    if (syncedOnPage) return;
    if (attributionSyncPromise) return attributionSyncPromise;

    const journey = captureAttribution();
    if (!journey) return;

    const root = window.Shopify?.routes?.root || '/';
    attributionSyncPromise = fetch(root + 'cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ attributes: privateCartAttributes(journey) }),
    })
      .then((response) => {
        if (!response.ok) throw new Error('Attribution sync failed');
        syncedOnPage = true;
      })
      .catch(() => undefined)
      .finally(() => {
        attributionSyncPromise = undefined;
      });

    return attributionSyncPromise;
  };

  captureAttribution();

  document.addEventListener('cart:update', (event) => {
    if (event.detail?.data?.didError) return;
    syncAttributionToCart();
  });

  document.addEventListener('visitorConsentCollected', () => {
    captureAttribution();
    if (window.location.pathname.endsWith('/cart') || document.querySelector('.accelerated-checkout-block')) {
      syncAttributionToCart();
    }
  });

  const hasAcceleratedCheckout = Boolean(document.querySelector('.accelerated-checkout-block'));

  if (window.location.pathname.endsWith('/cart') || hasAcceleratedCheckout) syncAttributionToCart();

  document.addEventListener(
    'pointerdown',
    (event) => {
      if (!(event.target instanceof Element)) return;
      if (!event.target.closest('.accelerated-checkout-block, .additional-checkout-buttons')) return;
      syncAttributionToCart();
    },
    { capture: true, passive: true }
  );
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["qomoor-nov-cro"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('qm-delivery')) {
    customElements.define('qm-delivery', class extends HTMLElement {
      static storeDate(now) {
        const parts = new Intl.DateTimeFormat('en-US', {timeZone:'Asia/Shanghai', year:'numeric', month:'numeric', day:'numeric'}).formatToParts(now);
        const value = type => Number(parts.find(part => part.type === type).value);
        return new Date(Date.UTC(value('year'), value('month') - 1, value('day')));
      }
      static businessDate(orderDate, days) {
        const date = new Date(orderDate);
        // The start date is day zero. Weekend orders start from the following Monday.
        while (date.getUTCDay() === 0 || date.getUTCDay() === 6) date.setUTCDate(date.getUTCDate() + 1);
        while (days > 0) {
          date.setUTCDate(date.getUTCDate() + 1);
          if (date.getUTCDay() !== 0 && date.getUTCDay() !== 6) days--;
        }
        return date;
      }
      static estimates(now) {
        const today = this.storeDate(now);
        const format = date => new Intl.DateTimeFormat('en-US', {month:'short', day:'numeric', timeZone:'UTC'}).format(date);
        return {
          today,
          standard: [6, 12].map(days => format(this.businessDate(today, days))),
          expedited: [5, 8].map(days => format(this.businessDate(today, days)))
        };
      }
      connectedCallback() {
        this.onResume = () => { if (!document.hidden) { this.refresh(); this.scheduleMidnight(); } };
        this.refresh();
        this.deliveryFrame = requestAnimationFrame(() => this.refresh());
        this.scheduleMidnight();
        document.addEventListener('visibilitychange', this.onResume);
        window.addEventListener('pageshow', this.onResume);
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.deliveryFrame);
        clearTimeout(this.deliveryTimer);
        document.removeEventListener('visibilitychange', this.onResume);
        window.removeEventListener('pageshow', this.onResume);
      }
      scheduleMidnight() {
        clearTimeout(this.deliveryTimer);
        const now = new Date();
        const day = this.constructor.storeDate(now);
        // Convert the next store midnight to an instant; UTC+8 has no daylight-saving changes.
        const delay = day.getTime() + 86400000 - 8 * 3600000 - now.getTime() + 50;
        this.deliveryTimer = setTimeout(() => { this.refresh(); this.scheduleMidnight(); }, Math.max(50, delay));
      }
      refresh(now = new Date()) {
        const {today, standard, expedited} = this.constructor.estimates(now);
        const standardText = this.querySelector('[data-qm-standard]');
        const expeditedText = this.querySelector('[data-qm-expedited]');
        if (standardText) standardText.textContent = `Arrives ${standard[0]} – ${standard[1]}`;
        if (expeditedText) expeditedText.textContent = `Expedited arrives ${expedited[0]} – ${expedited[1]} · $9.99`;
        const december = today.getUTCMonth() === 11;
        const afterStandard = december && today.getUTCDate() > 4;
        const afterExpedited = december && today.getUTCDate() > 11;
        const enabled = this.dataset.cutoffEnabled === 'true';
        const gift = this.querySelector('[data-qm-gift]');
        const giftText = this.querySelector('[data-qm-gift-text]');
        if (gift) gift.hidden = !enabled || afterExpedited;
        if (giftText) giftText.textContent = afterStandard ? 'Order Expedited by Dec 11 for Christmas' : 'Arrives before Christmas';
        const scope = this.closest('.product-details') || this.closest('.shopify-section');
        const accordion = scope && [...scope.querySelectorAll('details')].find(node => node.querySelector('summary')?.textContent.includes('Shipping & Delivery'));
        const holiday = accordion && [...accordion.querySelectorAll('p')].find(node => node.textContent.startsWith('Christmas delivery:'));
        if (!holiday) return;
        holiday.classList.add('qm-christmas-cutoff');
        holiday.hidden = !enabled || afterExpedited;
        // Keep the rich-text label bold when only Expedited remains available.
        const label = holiday.querySelector('strong');
        if (!label) return;
        const copy = afterStandard ? ' Order by Dec 11 (Expedited).' : ' Order by Dec 4 (Standard) or Dec 11 (Expedited).';
        if (holiday.textContent === label.textContent + copy) return;
        for (const node of [...holiday.childNodes]) if (node !== label) node.remove();
        holiday.append(document.createTextNode(copy));
      }
    });
  }

  if (!customElements.get('qm-guide-products')) {
    customElements.define('qm-guide-products', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.placed) return;
        const formatter = this.closest('.section-content-wrapper')?.querySelector('.blog-post-content rte-formatter');
        if (!formatter) return;
        const content = formatter.querySelector('article') || formatter;
        const paragraphs = content.querySelectorAll('p');
        if (paragraphs.length > 3) {
          let anchor = paragraphs[2];
          while (anchor.parentElement && anchor.parentElement !== content) anchor = anchor.parentElement;
          this.dataset.placed='true';
          anchor.after(this);
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
